(function () {
  'use strict';

  /* Comulytic Sales 页各 section 的交互脚本，拆分自原 Custom Liquid 内联 <script>。
     模块通过 data 属性挂载，init 幂等，支持 shopify:section:load 重挂。 */

  function formatMoney(cents, format) {
    cents = Math.round(+cents || 0);
    return window.Shopify && window.Shopify.formatMoney
      ? window.Shopify.formatMoney(cents, format || window.comulyticSalesMoneyFormat)
      : '$' + (cents / 100).toFixed(2) + ' USD';
  }

  /* ---- Buy Now 直达结账（featured 变体卡等处的 data-comulytic-sales-buy-now） ---- */
  function goToCart(variantId, quantity) {
    if (variantId) {
      window.location.href = '/cart/' + encodeURIComponent(variantId) + ':' + (+quantity || 1);
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-comulytic-sales-buy-now]');
    if (b) {
      e.preventDefault();
      goToCart(b.dataset.variantId, b.dataset.quantity);
    }
  });

  /* ---- Add to Cart（原生加购 + 打开主题购物车抽屉，复刻 theme.js ProductForm 流程） ---- */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartTypeSetting() {
    return (
      (window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.cartType) ||
      'drawer'
    );
  }

  function addToCartAndReveal(variantId, quantity) {
    var root = cartRoot();
    var bundledSections = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: bundledSections }
      })
    );

    var formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', quantity || 1);
    formData.set('sections', bundledSections.join(','));
    formData.set('sections_url', root + 'variants/' + variantId);

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          throw new Error('cart add failed');
        }
        if (cartTypeSetting() === 'page') {
          window.location.href = root + 'cart';
          return;
        }
        return fetch(root + 'cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            cart.sections = result.json.sections;
            var items = result.json.items || [result.json];
            document.documentElement.dispatchEvent(
              new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cart } })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', cart: cart }
              })
            );
          });
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-comulytic-add]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    var variantId = b.getAttribute('data-variant-id');
    var quantity = parseInt(b.getAttribute('data-quantity'), 10) || 1;
    var fallbackHref = b.getAttribute('href');
    if (!variantId) {
      if (fallbackHref) window.location.href = fallbackHref;
      return;
    }
    b.setAttribute('aria-busy', 'true');
    addToCartAndReveal(variantId, quantity)
      .then(function () {
        b.removeAttribute('aria-busy');
      })
      .catch(function () {
        b.removeAttribute('aria-busy');
        if (fallbackHref) window.location.href = fallbackHref;
      });
  });

  /* ---- 产品图轮播（featured section） ---- */
  function initCarousel(root) {
    if (!root || root.dataset.comulyticCarouselReady === 'true') return;
    var imgs = Array.prototype.slice.call(root.querySelectorAll('.comulytic-sales__carousel-image'));
    if (!imgs.length) return;
    root.dataset.comulyticCarouselReady = 'true';

    var dots = Array.prototype.slice.call(root.querySelectorAll('.comulytic-sales__carousel-dot'));
    var prev = root.querySelector('.comulytic-sales__carousel-arrow--prev');
    var next = root.querySelector('.comulytic-sales__carousel-arrow--next');
    var i = 0;
    var timer;

    function show(n) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (x, k) { x.classList.toggle('comulytic-sales__carousel-image--active', k === i); });
      dots.forEach(function (x, k) { x.classList.toggle('comulytic-sales__carousel-dot--active', k === i); });
    }
    function play() {
      clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, 3500);
    }
    if (prev) prev.onclick = function () { show(i - 1); play(); };
    if (next) next.onclick = function () { show(i + 1); play(); };
    dots.forEach(function (d, k) { d.onclick = function () { show(k); play(); }; });
    show(0);
    play();
  }

  /* ---- FAQ 手风琴 ---- */
  function initFaq(root) {
    if (!root || root.dataset.comulyticFaqReady === 'true') return;
    root.dataset.comulyticFaqReady = 'true';

    root.querySelectorAll('.comulytic-sales__faq-item').forEach(function (item) {
      var btn = item.querySelector('.comulytic-sales__faq-toggle');
      var panel = item.querySelector('.comulytic-sales__faq-panel');
      if (!btn || !panel) return;
      panel.hidden = true;
      btn.onclick = function (e) {
        e.preventDefault();
        var open = btn.getAttribute('aria-expanded') !== 'true';
        root.querySelectorAll('.comulytic-sales__faq-item').forEach(function (other) {
          var b = other.querySelector('.comulytic-sales__faq-toggle');
          var p = other.querySelector('.comulytic-sales__faq-panel');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (p) p.hidden = true;
          other.classList.remove('comulytic-sales__faq-item--open');
        });
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
        item.classList.toggle('comulytic-sales__faq-item--open', open);
      };
    });
  }

  /* ---- 锚点 Tabs：JS fixed 吸顶（吸在 header/公告栏下方）+ 移动端横向滚动 ---- */
  function initTabs(root) {
    if (!root || root.dataset.comulyticTabsReady === 'true') return;
    var tabs = root.querySelector('.comulytic-sales__tabs');
    if (!tabs) return;
    var tabsInner = tabs.querySelector('.comulytic-sales__tabs-inner');
    var section = root.closest('.shopify-section');
    root.dataset.comulyticTabsReady = 'true';

    var MOBILE_TABS = window.matchMedia('(max-width: 1023px)');

    function scrollTabsToStart() {
      if (!tabsInner || !MOBILE_TABS.matches) return;
      tabsInner.scrollLeft = 0;
    }

    scrollTabsToStart();
    window.addEventListener('resize', scrollTabsToStart);
    setTimeout(scrollTabsToStart, 80);
    setTimeout(scrollTabsToStart, 600);

    var tabLinks = tabs.querySelectorAll('.comulytic-sales__tab');

    function stickyOffset() {
      // 优先量 Header 组实际底部，避免 --header-height 取整后与真实高度差 1px 缝隙
      var bottom = 0;
      document
        .querySelectorAll('.shopify-section-group-header-group > .shopify-section')
        .forEach(function (el) {
          var style = getComputedStyle(el);
          if (style.position !== 'sticky' && style.position !== 'fixed') return;
          if (style.display === 'none' || style.visibility === 'hidden') return;
          var rect = el.getBoundingClientRect();
          if (rect.height > 0 && rect.bottom > bottom) bottom = rect.bottom;
        });
      if (bottom > 0) {
        // PC 叠 1px 盖住亚像素缝；移动端贴齐即可
        var overlap = window.matchMedia('(min-width: 1024px)').matches ? 1 : 0;
        return Math.max(0, Math.floor(bottom) - overlap);
      }

      var probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText =
        'position:fixed;left:0;width:0;height:0;visibility:hidden;pointer-events:none;' +
        'top:var(--sale-tabs-sticky-top, calc(var(--header-is-visible, 1) * var(--sticky-area-height, var(--header-height, 0px))));';
      document.body.appendChild(probe);
      var top = probe.getBoundingClientRect().top;
      probe.remove();
      return Math.max(0, Math.floor(top));
    }

    function setActiveTab(activeTab) {
      if (!activeTab) return;
      tabLinks.forEach(function (tab) {
        var on = tab === activeTab;
        tab.classList.toggle('comulytic-sales__tab--active', on);
        if (on) tab.setAttribute('aria-current', 'true');
        else tab.removeAttribute('aria-current');
      });
    }

    function tabFromHash(hash) {
      if (!hash || hash === '#') return null;
      var key = hash.charAt(0) === '#' ? hash : '#' + hash;
      for (var i = 0; i < tabLinks.length; i++) {
        var href = tabLinks[i].getAttribute('href') || '';
        if (href === key || href === hash || href.split('#')[1] === key.slice(1)) {
          return tabLinks[i];
        }
      }
      return null;
    }

    function scrollToTabTarget(tab) {
      var href = tab.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return false;
      var id = href.slice(1);
      if (!id) return false;
      var target = document.getElementById(id);
      if (!target) return false;
      var offset = stickyOffset() + (section ? section.offsetHeight : tabs.offsetHeight) + 8;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      if (history.replaceState) history.replaceState(null, '', href);
      else location.hash = href;
      return true;
    }

    if (location.hash) {
      setActiveTab(tabFromHash(location.hash));
    } else {
      var initial = tabs.querySelector('.comulytic-sales__tab--active') || tabLinks[0];
      setActiveTab(initial);
    }

    tabLinks.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        setActiveTab(tab);
        if (scrollToTabTarget(tab)) e.preventDefault();
        if (MOBILE_TABS.matches && tabsInner) {
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      });
    });

    window.addEventListener('hashchange', function () {
      var fromHash = tabFromHash(location.hash);
      if (fromHash) setActiveTab(fromHash);
    });

    if (!section || section.dataset.comulyticTabsPinReady === 'true') return;
    section.dataset.comulyticTabsPinReady = 'true';

    var spacer = document.createElement('div');
    spacer.setAttribute('data-comulytic-tabs-spacer', '');
    spacer.setAttribute('aria-hidden', 'true');
    section.parentNode.insertBefore(spacer, section);

    var pinned = false;

    function pin(offset) {
      if (pinned) return;
      spacer.style.display = 'block';
      spacer.style.height = section.offsetHeight + 'px';
      section.classList.add('is-comulytic-tabs-fixed');
      section.style.top = offset + 'px';
      pinned = true;
    }

    function unpin() {
      if (!pinned) return;
      section.classList.remove('is-comulytic-tabs-fixed');
      section.style.removeProperty('top');
      spacer.style.display = 'none';
      spacer.style.height = '';
      pinned = false;
    }

    function updatePin() {
      var offset = stickyOffset();
      if (!pinned) {
        if (section.getBoundingClientRect().top <= offset) pin(offset);
        return;
      }
      section.style.top = offset + 'px';
      if (spacer.getBoundingClientRect().top > offset) unpin();
    }

    window.addEventListener('scroll', updatePin, { passive: true });
    window.addEventListener('resize', updatePin);
    updatePin();
    setTimeout(updatePin, 100);
    setTimeout(updatePin, 500);
  }

  /* ---- Bundle 算价器（档位数据来自 data-bundle-offers JSON，由 schema blocks 渲染） ---- */
  function initBundle(root) {
    if (!root || root.dataset.comulyticBundleReady === 'true') return;
    var panel = root.querySelector('[data-comulytic-bundle]');
    if (!panel) return;
    root.dataset.comulyticBundleReady = 'true';

    var moneyFormat = root.dataset.moneyFormat || window.comulyticSalesMoneyFormat;
    var productUrl = root.dataset.productUrl || '/products/comulytic-note-pro';
    var customStatusTemplate = root.dataset.bundleCustomStatusTemplate || 'Auto saves an extra {percent}% off at checkout (Code: {code}).';
    var customStatusFallback = root.dataset.bundleCustomStatusFallback || 'Bulk discount starts from 2 units.';

    var offers = [];
    try {
      offers = JSON.parse(root.dataset.bundleOffers || '[]');
    } catch (err) {
      offers = [];
    }
    offers = offers
      .map(function (o) { return { min: +o.min || 0, code: String(o.code || ''), pct: +o.pct || 0 }; })
      .filter(function (o) { return o.min > 1 && o.code; })
      .sort(function (a, b) { return b.min - a.min; });

    function money(c) { return formatMoney(c, moneyFormat); }
    function formatCustomStatus(bulk, code) {
      if (bulk && code) {
        return customStatusTemplate
          .replace(/\{percent\}/g, String(bulk))
          .replace(/\{code\}/g, String(code));
      }
      return customStatusFallback;
    }
    function offer(q) {
      q = Math.max(1, +q || 1);
      for (var k = 0; k < offers.length; k++) {
        if (q >= offers[k].min) return [offers[k].code, offers[k].pct];
      }
      return ['', 0];
    }
    function sw() { return root.querySelector('.comulytic-sales__bundle-swatch--active') || root.querySelector('.comulytic-sales__bundle-swatch'); }
    function tier() { return root.querySelector('.comulytic-sales__bundle-tier--active') || root.querySelector('.comulytic-sales__bundle-tier'); }
    function vid() { var s = sw(); return s ? s.dataset.variantId : ''; }
    function price() { var s = sw(); return s ? +s.dataset.price : 0; }
    function comp() { var s = sw(); return s ? +s.dataset.comparePrice : 0; }
    function qty(t) {
      if (!t) return 1;
      if (t.dataset.bundleTier === 'custom') {
        var i = root.querySelector('[data-bundle-quantity]');
        var q = i ? parseInt(i.value, 10) : 1;
        q = !q || q < 1 ? 1 : q;
        if (i) i.value = q;
        return q;
      }
      return Math.max(1, +t.dataset.quantity || 1);
    }
    function calc(q) {
      var p = price();
      var c = comp();
      var o = offer(q);
      var total = p * q - Math.floor(p * o[1] / 100) * q;
      var was = c * q;
      var pct = was ? Math.round(Math.max(was - total, 0) * 100 / was) : 0;
      return { q: q, total: total, was: was, unit: total / q, pct: pct, code: o[0], bulk: o[1] };
    }
    function set(sel, txt) { var e = root.querySelector(sel); if (e) e.textContent = txt; }
    function active(el, sel, cls) {
      root.querySelectorAll(sel).forEach(function (x) {
        x.classList.remove(cls);
        x.setAttribute('aria-checked', 'false');
      });
      el.classList.add(cls);
      el.setAttribute('aria-checked', 'true');
    }
    function customState() {
      var isCustom = tier() && tier().dataset.bundleTier === 'custom';
      var row = root.querySelector('[data-bundle-custom-row]');
      if (row) row.classList.toggle('is-active', isCustom);
    }
    function updateLinks() {
      var id = vid();
      var a = root.querySelector('[data-bundle-image-link]');
      if (a && id) a.href = productUrl + '?variant=' + encodeURIComponent(id);
    }
    function update() {
      customState();
      updateLinks();
      root.querySelectorAll('.comulytic-sales__bundle-tier').forEach(function (t) {
        var r = calc(qty(t));
        var n = t.querySelector('[data-bundle-tier-price-now]');
        var w = t.querySelector('[data-bundle-tier-price-was]');
        var p = t.querySelector('[data-bundle-save-pill]');
        if (n) n.textContent = money(r.total);
        if (w) w.textContent = money(r.was);
        if (p) p.textContent = r.pct ? 'Save ' + r.pct + '%' : 'Sale';
      });
      var r = calc(qty(tier()));
      set('[data-bundle-total]', money(r.total));
      set('[data-bundle-total-was]', money(r.was));
      set('[data-bundle-per-unit]', money(r.unit));
      set('[data-bundle-per-unit-meta]', '× ' + r.q + ' units');
      set('[data-bundle-custom-status]', formatCustomStatus(r.bulk, r.code));
      set('[data-bundle-disclaimer]', r.code ? 'Bulk discount auto-applies at checkout. Code: ' + r.code + '.' : 'Bulk discount starts from 2 units.');
    }

    root.querySelectorAll('.comulytic-sales__bundle-swatch').forEach(function (b) {
      b.onclick = function () {
        active(b, '.comulytic-sales__bundle-swatch', 'comulytic-sales__bundle-swatch--active');
        set('[data-bundle-color-label]', 'Color: ' + b.dataset.bundleColor);
        update();
      };
    });
    root.querySelectorAll('.comulytic-sales__bundle-tier').forEach(function (b) {
      b.onclick = function () {
        active(b, '.comulytic-sales__bundle-tier', 'comulytic-sales__bundle-tier--active');
        update();
      };
    });

    var qi = root.querySelector('[data-bundle-quantity]');
    var mi = root.querySelector('[data-bundle-quantity-minus]');
    var pl = root.querySelector('[data-bundle-quantity-plus]');
    if (qi) {
      qi.oninput = update;
      qi.onchange = update;
    }
    if (mi) mi.onclick = function () { qi.value = Math.max(1, qty(tier()) - 1); update(); };
    if (pl) pl.onclick = function () { qi.value = qty(tier()) + 1; update(); };

    function addToCart(id, q) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +id, quantity: +q || 1 }] })
      });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bundle-buy]');
      if (b) {
        e.preventDefault();
        goToCart(vid(), qty(tier()));
        return;
      }
      b = e.target.closest('[data-bundle-add]');
      if (b) {
        e.preventDefault();
        b.disabled = true;
        addToCart(vid(), qty(tier())).then(function () {
          try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } catch (err) { /* ignore */ }
          setTimeout(function () {
            var opened = false;
            var drawer = document.querySelector('cart-drawer,#cart-drawer,.cart-drawer,[data-cart-drawer]');
            var trigger = document.querySelector('[aria-controls="cart-drawer"],[data-cart-drawer-opener],#cart-icon-bubble,a[href="/cart"]');
            if (trigger) {
              try { trigger.click(); opened = true; } catch (err) { /* ignore */ }
            }
            if (!opened && drawer) {
              try {
                if (typeof drawer.open === 'function') { drawer.open(); opened = true; }
                else if (typeof drawer.show === 'function') { drawer.show(); opened = true; }
                else {
                  drawer.setAttribute('open', '');
                  drawer.removeAttribute('hidden');
                  drawer.setAttribute('aria-hidden', 'false');
                  opened = true;
                }
              } catch (err) { /* ignore */ }
            }
            if (!opened) window.location.href = '/cart';
            b.disabled = false;
          }, 120);
        }).catch(function () {
          window.location.href = '/cart';
        });
      }
    });

    update();
  }

  /* ---- YouTube 视频卡片区 ---- */
  function initVideos(root) {
    if (!root || root.dataset.comulyticVideosReady === 'true') return;
    var track = root.querySelector('[data-video-track]');
    var modal = root.querySelector('[data-video-modal]');
    var frame = root.querySelector('[data-video-frame]');
    var progress = root.querySelector('[data-progress-bar]');
    if (!track || !modal || !frame) return;
    root.dataset.comulyticVideosReady = 'true';

    var pendingAutoplay = false;

    /* 首次点击即播放：
       1) 先显示弹窗再设 iframe src（隐藏 iframe 内 autoplay 会被浏览器拦截）
       2) mute=1 + autoplay=1 保证静音自动播放
       3) enablejsapi + origin + onReady 后 postMessage 触发 playVideo / unMute */
    function buildEmbedUrl(id) {
      return (
        'https://www.youtube-nocookie.com/embed/' +
        encodeURIComponent(id) +
        '?autoplay=1&mute=1&enablejsapi=1&rel=0&modestbranding=1&playsinline=1&origin=' +
        encodeURIComponent(window.location.origin)
      );
    }

    function ytCommand(func, args) {
      try {
        if (frame.contentWindow) {
          frame.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: func,
              args: args !== undefined ? args : ''
            }),
            '*'
          );
        }
      } catch (err) {
        /* ignore */
      }
    }

    function startPlayback() {
      ytCommand('playVideo');
      ytCommand('unMute');
    }

    function handleYoutubeMessage(event) {
      if (event.source !== frame.contentWindow || !pendingAutoplay) return;
      var data;
      try {
        data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      } catch (err) {
        return;
      }
      if (data && data.event === 'onReady') {
        startPlayback();
      }
    }

    window.addEventListener('message', handleYoutubeMessage);

    frame.addEventListener('load', function () {
      if (!pendingAutoplay || !frame.getAttribute('src')) return;
      startPlayback();
      setTimeout(startPlayback, 250);
      setTimeout(startPlayback, 750);
    });

    function openVideo(id) {
      if (!id) return;
      pendingAutoplay = true;
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        frame.src = buildEmbedUrl(id);
      });
    }
    function closeVideo() {
      pendingAutoplay = false;
      modal.classList.remove('is-active');
      frame.src = '';
      document.body.style.overflow = '';
    }
    function updateProgress() {
      if (!progress) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var percent = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      progress.style.transform = 'translateX(' + percent * 200 + '%)';
    }

    root.querySelectorAll('.comulytic-video-card').forEach(function (card) {
      card.addEventListener('click', function () { openVideo(card.dataset.youtubeId); });
    });
    var prev = root.querySelector('[data-video-prev]');
    var next = root.querySelector('[data-video-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' }); });
    var close = root.querySelector('[data-video-close]');
    if (close) close.addEventListener('click', closeVideo);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeVideo();
    });
    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  }

  /* ---- Sale Banner 倒计时 blocks ---- */
  function padCountdown(value) {
    var n = Math.max(0, Math.floor(+value || 0));
    return n < 10 ? '0' + n : String(n);
  }

  function parseCountdownEndMs(isoEnd, timeZone) {
    var match = String(isoEnd || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/);
    if (!match) return NaN;

    var wish = {
      year: +match[1],
      month: +match[2],
      day: +match[3],
      hour: +match[4],
      minute: +match[5],
      second: +match[6]
    };

    if (!timeZone) {
      return Date.UTC(wish.year, wish.month - 1, wish.day, wish.hour, wish.minute, wish.second);
    }

    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    function readParts(ms) {
      var map = {};
      formatter.formatToParts(new Date(ms)).forEach(function (part) {
        if (part.type !== 'literal') map[part.type] = part.value;
      });
      return {
        year: +map.year,
        month: +map.month,
        day: +map.day,
        hour: +map.hour % 24,
        minute: +map.minute,
        second: +map.second
      };
    }

    var guess = Date.UTC(wish.year, wish.month - 1, wish.day, wish.hour, wish.minute, wish.second);
    for (var i = 0; i < 6; i++) {
      var got = readParts(guess);
      var diff =
        (((wish.year - got.year) * 365 + (wish.month - got.month) * 30 + (wish.day - got.day)) * 86400000) +
        (wish.hour - got.hour) * 3600000 +
        (wish.minute - got.minute) * 60000 +
        (wish.second - got.second) * 1000;
      if (Math.abs(diff) < 1000) break;
      guess += diff;
    }
    return guess;
  }

  function initBannerCountdown(root) {
    if (!root || root.dataset.comulyticCountdownReady === 'true') return;

    var endMs = parseCountdownEndMs(root.getAttribute('data-end'), root.getAttribute('data-timezone'));
    if (!isFinite(endMs)) return;

    root.dataset.comulyticCountdownReady = 'true';

    var activeEl = root.querySelector('[data-countdown-active]');
    var expiredEl = root.querySelector('[data-countdown-expired]');
    var hideWhenExpired = root.getAttribute('data-hide-when-expired') === 'true';
    var daysEl = root.querySelector('[data-countdown-days]');
    var hoursEl = root.querySelector('[data-countdown-hours]');
    var minutesEl = root.querySelector('[data-countdown-minutes]');
    var secondsEl = root.querySelector('[data-countdown-seconds]');

    function setExpiredState() {
      if (hideWhenExpired) {
        root.hidden = true;
        return;
      }
      if (activeEl) activeEl.hidden = true;
      if (expiredEl) {
        expiredEl.hidden = false;
        return;
      }
      if (daysEl) daysEl.textContent = '00';
      if (hoursEl) hoursEl.textContent = '00';
      if (minutesEl) minutesEl.textContent = '00';
      if (secondsEl) secondsEl.textContent = '00';
    }

    function tick() {
      var remaining = endMs - Date.now();
      if (remaining <= 0) {
        setExpiredState();
        if (root._comulyticCountdownTimer) {
          clearInterval(root._comulyticCountdownTimer);
          root._comulyticCountdownTimer = null;
        }
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var seconds = totalSeconds % 60;
      var totalMinutes = Math.floor(totalSeconds / 60);
      var minutes = totalMinutes % 60;
      var totalHours = Math.floor(totalMinutes / 60);
      var hours = totalHours % 24;
      var days = Math.floor(totalHours / 24);

      if (daysEl) daysEl.textContent = padCountdown(days);
      if (hoursEl) hoursEl.textContent = padCountdown(hours);
      if (minutesEl) minutesEl.textContent = padCountdown(minutes);
      if (secondsEl) secondsEl.textContent = padCountdown(seconds);
    }

    tick();
    root._comulyticCountdownTimer = setInterval(tick, 1000);
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.forEach.call(container.querySelectorAll('[data-comulytic-carousel]'), initCarousel);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comulytic-faq]'), initFaq);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comulytic-tabs]'), initTabs);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comulytic-bundle-module]'), initBundle);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comulytic-videos]'), initVideos);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comulytic-countdown]'), initBannerCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
